export default __webpack_public_path__ + "static/media/a.3c5ab485.jpg";